// extracted by css-extract-rspack-plugin
export default {"membershipSelectItem":"dzaoL"};